import {
  GET_BUDGETS_PERCENTAGE_SUCCESS,
  GET_BUDGETS_PERCENTAGE_FAIL,
  GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS,
  GET_BUDGET_PERCENTAGE_PROFILE_FAIL,
  ADD_BUDGET_PERCENTAGE_SUCCESS,
  ADD_BUDGET_PERCENTAGE_FAIL,
  UPDATE_BUDGET_PERCENTAGE_SUCCESS,
  UPDATE_BUDGET_PERCENTAGE_FAIL,
  DELETE_BUDGET_PERCENTAGE_SUCCESS,
  DELETE_BUDGET_PERCENTAGE_FAIL,
  DELETE_BUDGET_PERCENTAGE,
  ADD_NEW_BUDGET_PERCENTAGE,
  UPDATE_BUDGET_PERCENTAGE
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  total_page:0,
  error: {},
  loading:false
};

const budgets_percentage = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_BUDGETS_PERCENTAGE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page: action.payload.total_page,
      }

    case GET_BUDGETS_PERCENTAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_BUDGET_PERCENTAGE:
        return {
          ...state,
          loading:true
        }
    case ADD_BUDGET_PERCENTAGE_SUCCESS:
      return {
        ...state,
        // data: [...state.data, action.payload],
        loading: false,
      }

    case ADD_BUDGET_PERCENTAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_BUDGET_PERCENTAGE:
        return {
          ...state,
          loading:true
        }
    case UPDATE_BUDGET_PERCENTAGE_SUCCESS:
      return {
        ...state,
        data: state.data.map(ceremony =>
          ceremony.id.toString() === action.payload.id.toString()
            ? { ...ceremony, ...action.payload }
            : ceremony
        ),
        loading: false,
      }

    case UPDATE_BUDGET_PERCENTAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_BUDGET_PERCENTAGE:
      return {
        ...state,
        loading:true
      }
    case DELETE_BUDGET_PERCENTAGE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          ceremony => ceremony.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_BUDGET_PERCENTAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS:
      return {
        ...state,
        ceremonyProfile: action.payload,
      }

    case GET_BUDGET_PERCENTAGE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default budgets_percentage;
